/**
 * External dependencies
 */
export { View } from 'react-native';
